import { useContext, useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Card,
  Col,
  Collapse,
  Divider,
  Rate,
  Row,
  Skeleton,
  Tooltip,
} from 'antd';
import axios from 'axios';
import DashboardContext from 'Context';
import { Form } from 'react-bootstrap';
import Pagination from 'components/tabel/Pagination';
import InputNumber from 'components/inputs/InputNumber';
import InputControl from 'components/inputs/InputControl';
import InputDate from 'components/inputs/InputDate';
import InputControlAsync from 'components/inputs/InputControlAsync';

// مشتری به نیرو

const CustomerToWorker = ({ type = 'customer' }) => {
  const { urldashboard, authentication, handelerrors, idview } =
    useContext(DashboardContext);

  const [data, setData] = useState([]);
  const [filterData, setFilterData] = useState({});
  const [isLoading, setIsLoading] = useState({});

  const [page, setPage] = useState(
    JSON.parse(sessionStorage.getItem('startpage')) || 1
  );
  const [pageSize, setPageSize] = useState(
    JSON.parse(sessionStorage.getItem('pageSize')) || 9
  );

  const getList = async ({ page, pageSize, filterData }) => {
    const customerQuery = {
      page: parseInt(page),
      pageSize: parseInt(pageSize),
      ...filterData,
      customerId: JSON.parse(sessionStorage.getItem('customerid')) || idview,
    };

    const workerQuery = {
      page: parseInt(page),
      pageSize: parseInt(pageSize),
      ...filterData,
      workerId: JSON.parse(sessionStorage.getItem('workerId'))
        ? JSON.parse(sessionStorage.getItem('workerId'))
        : idview,
    };

    setIsLoading(true);

    try {
      const res = await axios.post(
        `${urldashboard}/worker/surveyReport`,
        JSON.stringify(type === 'customer' ? customerQuery : workerQuery),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );

      const data = await res.data;

      setData(data);
      setIsLoading(false);
    } catch (error) {
      handelerrors(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    search();
  }, [page, pageSize]);

  const search = () => {
    getList({
      page,
      pageSize,
      filterData,
    });
  };

  const handlePageNumber = (number) => {
    sessionStorage.setItem('startpage', JSON.stringify(number));
    setPage(number);
  };

  const handlePrevPage = () => {
    if (parseInt(data?.page) === 1) {
    } else {
      sessionStorage.setItem('startpage', JSON.stringify(page - 1));
      setPage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (data?.page === data?.totalPage) {
    } else {
      sessionStorage.setItem('startpage', JSON.stringify(page + 1));
      setPage(page + 1);
    }
  };

  const arrayOfPageSizes = [9, 18, 50, 100, 500, 1000, 2000];
  const handleRow = (e) => {
    setPageSize(parseInt(e.target.value));
    sessionStorage.setItem(
      'pageSize',
      JSON.stringify(parseInt(e.target.value))
    );
    sessionStorage.setItem('startpage', JSON.stringify(1));
    sessionStorage.setItem('Pagination', JSON.stringify([]));

    setPage(1);
  };

  const handleChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };

  return (
    <Row style={{ margin: '3rem 0' }}>
      <Col span={24}>
        <Row align={'middle'}>
          <Col span={12}>
            <Divider orientation='left' orientationMargin='0%'>
              <h3>مشتری به نیرو</h3>
            </Divider>
          </Col>
          <Col span={12}>
            <Divider orientation='right' orientationMargin='0%'></Divider>
          </Col>
        </Row>
        {data?.length < 1 ? (
          <Row>
            <Col span={24}>
              <Alert message={'نظری تاکنون ثبت نشده است.'} type='warning' />
            </Col>
          </Row>
        ) : (
          <>
            <div style={{ display: 'flex' }}>
              <div style={{ flex: 1 }}>
                <Collapse defaultActiveKey={['0']}>
                  <Collapse.Panel header='جستجو پیشرفته' key='1'>
                    {/* */}
                    <Row gutter={20}>
                      <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                        <InputControlAsync
                          url='/userManagement/searchdropdown'
                          label='انتخاب مشتری'
                          name='customerUserId'
                          handelValue={(_, value) =>
                            handleChange('customerUserId', value)
                          }
                        />
                      </Col>
                      <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                        <InputDate
                          label='تاریخ سفارش'
                          name='workStartDate'
                          handelValue={(_, value) =>
                            handleChange('workStartDate', value)
                          }
                        />
                      </Col>
                      <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                        <InputNumber
                          label='تعداد ستاره های دریافتی نیرو'
                          name='star'
                          handelValue={(_, value) =>
                            handleChange('star', value)
                          }
                        />
                      </Col>
                    </Row>
                    <Row gutter={20}>
                      <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                        <InputControl
                          url={`/category/dropdown/1`}
                          label={
                            <div>
                              خدمت سفارش
                              <small>
                                {' '}
                                (برای فیلتر کردن اطلاعات، لطفا زیرخدمت را انتخاب
                                کنید.)
                              </small>
                            </div>
                          }
                          name='categoryId'
                          handelValue={(_, value) =>
                            handleChange('categoryId', value)
                          }
                        />
                      </Col>
                      <Col xl={8} lg={8} md={12} sm={12} xs={24}>
                        {filterData?.categoryId && (
                          <InputControl
                            url={`/group/groupDropdown/${filterData?.categoryId}/false`}
                            label='زیرخدمت سفارش'
                            name='groupId'
                            handelValue={(_, value) =>
                              handleChange('groupId', value)
                            }
                          />
                        )}
                      </Col>
                    </Row>
                    {/* */}
                    <Row
                      gutter={20}
                      style={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        marginTop: 20,
                      }}
                    >
                      <Col xl={6} lg={6} md={24} sm={24} xs={24}>
                        <Button
                          type='primary'
                          style={{ width: '100%' }}
                          loading={isLoading}
                          onClick={() => search()}
                        >
                          جستجو
                        </Button>
                      </Col>
                    </Row>
                  </Collapse.Panel>
                </Collapse>
              </div>
            </div>

            <Row className='my-3 d-flex justify-content-between'>
              {/* <Col span={24} style={{ marginBottom: 20 }}>
                <Space
                  wrap
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    width: '100%',
                  }}
                >
                  <Excel
                    server
                    methodIsGet
                    fileName={`نظرات_نیرو_ب_واحدهای_کارلاین`}
                    url={'/workerKarlineSurvey/getExcel'}
                    props={{
                      workerId: idview,
                      page,
                      pageSize,
                    }}
                  />
                </Space>
              </Col> */}
              <Col
                md={5}
                sm={6}
                xs={12}
                className='d-flex align-items-baseline'
              >
                <Pagination
                  totalPage={data?.totalPage}
                  page={data?.page}
                  handelprevpage={handlePrevPage}
                  handelNextpage={handleNextPage}
                  handelpagenumber={handlePageNumber}
                />
              </Col>
              <Col
                md={4}
                sm={3}
                xs={6}
                className='d-flex align-items-end d-sm-block mt-sm-2'
              >
                <div className='d-flex ml-auto mr-sm-auto '>
                  <p>مجموع کل: </p>
                  <span className='mr-2'> {data?.totalRecord} </span>
                </div>
              </Col>
              <Col md={3} sm={3} xs={6} className='mt-sm-0 mt-3 mt-md-0'>
                <div className='rowminger'>
                  <p className='text-nowrap'>تعداد:</p>
                  <Form.Control size='sm' as='select' onChange={handleRow}>
                    {arrayOfPageSizes.map((item) => (
                      <option
                        key={item}
                        selected={item === pageSize ? true : false}
                        value={item}
                      >
                        {item}
                      </option>
                    ))}
                  </Form.Control>
                </div>
              </Col>
            </Row>

            <Row gutter={16}>
              {data?.data?.map((item) => (
                <Col span={8} className='mb-3'>
                  <Card
                    title={[
                      <div className='d-flex justify-content-between align-items-center'>
                        <div className='d-flex flex-column align-items-center'>
                          <span
                            style={{
                              color: 'rgba(0, 0, 0, 0.45)',
                            }}
                          >
                            توسط
                          </span>
                          <span>{item?.creatorName}</span>
                          <span
                            style={{
                              fontSize: '14px',
                              color: 'rgba(0, 0, 0, 0.45)',
                            }}
                          >
                            {item?.persianCreateDate}
                            {item?.createDate}
                          </span>
                        </div>
                        <div className='d-flex flex-column align-items-center'>
                          <span
                            style={{
                              color: 'rgba(0, 0, 0, 0.45)',
                            }}
                          >
                            تاریخ سفارش
                          </span>
                          <span>{item?.orderDate}</span>
                        </div>
                        <div className='d-flex flex-column align-items-center'>
                          <Tooltip
                            placement={'top'}
                            title={
                              <ul>
                                {item?.surveyAttributeResponses
                                  ?.filter((d) => d.surveyAttributeType === 1)
                                  .map((d) => (
                                    <li key={d.title}>{d.title}</li>
                                  ))}
                              </ul>
                            }
                          >
                            <span style={{ cursor: 'pointer' }}>نقاط قوت</span>
                          </Tooltip>
                          <Tooltip
                            style={{ cursor: 'pointer' }}
                            placement={'bottom'}
                            title={
                              <ul>
                                {item?.surveyAttributeResponses
                                  ?.filter((d) => d.surveyAttributeType === 2)
                                  .map((d) => (
                                    <li key={d.title}>{d.title}</li>
                                  ))}
                              </ul>
                            }
                          >
                            <span style={{ cursor: 'pointer' }}>نقاط ضعف</span>
                          </Tooltip>
                        </div>
                      </div>,
                    ]}
                    actions={[
                      <Rate
                        disabled
                        count={5}
                        value={item?.star}
                        style={{
                          direction: 'ltr',
                          color: '#252525',
                        }}
                      />,
                    ]}
                  >
                    <span style={{ wordBreak: 'break-word' }}>
                      {item?.description
                        ? item?.description
                        : 'نظری ثبت نشده است.'}
                    </span>
                  </Card>
                </Col>
              ))}
            </Row>
          </>
        )}
      </Col>
    </Row>
  );
};

export default CustomerToWorker;
